<div [hidden]="loggingIn" class="wm-l-login-form">
  <img class="wm-l-login-logo" src="/assets/img/webmate_Redesign_Logo_RGB_vereinfachung_positiv.svg">
  <div>
    @if (loginFailure) {
      <div class="wm-l-login-error" data-testing-id="login-errorfield">There was an error while logging in. <br>Please check your credentials and try again</div>
    }
    <div class="wm-l-login-form-field">
      <input (keydown.enter)="submitLogin()" [(ngModel)]="email" class="user-input" email name="email" type="text" tabindex="1" data-testing-id="login-userfield">
      <span class="label" [ngClass]="{'outside': email !== ''}">{{webmateOptions.instance === 'openshift-webmate-atruvia' ? 'x...@atruvia.de' : 'Email address'}}</span>
    </div>
    <div class="wm-l-login-form-field password">
      <input (keydown.enter)="submitLogin()" [(ngModel)]="password" class="user-input" type="password" name="password" tabindex="2" data-testing-id="login-passwordfield">
      <span class="label" [ngClass]="{'outside': password !== ''}">Password</span>
    </div>
    <button pButton class="wm-l-login-submitbutton" [disabled]="checkForm()" (click)="submitLogin()" data-testing-id="login-submit-button">Sign in</button>
    <div class="wm-l-login-second-line">
      @if (!demoInstance) {
        <div class="wm-l-login-forgot">
          <a routerLink="sso" [queryParamsHandling]="'preserve'" data-testing-id="sso-link">SSO Sign-In</a>
        </div>
      }
      @if (demoInstance) {
        <div class="wm-l-login-forgot">
          <a routerLink="/signup" data-testing-id="signup-link">Sign Up</a>
        </div>
      }
      <div class="wm-l-login-forgot link-align-left">
        <a routerLink="/resetpassword" data-testing-id="forgot-password-link">Forgot password?</a>
      </div>
    </div>
  </div>
</div>
<div [hidden]="!loggingIn">
  <div class="wm-l-login-spinner-wrapper">
    <div class="wm-l-login-spinner-msg">Logging in...</div>
    <p-progressSpinner class="wm-l-login-spinner"></p-progressSpinner>
  </div>
</div>
